"use client";

import { useContext } from "react";
import { useQuery as useUrqlQuery, type UseQueryArgs } from "urql";

import { BokunClientContext } from "~/app/admin/_components/urql-provider";

/**
 * Hook for querying Dato CMS using the default urql client
 */
export function useDatoQuery<
  Data = unknown,
  Variables extends Record<string, unknown> = Record<string, never>,
>(args: UseQueryArgs<Variables, Data>) {
  return useUrqlQuery(args);
}

/**
 * Hook for querying Bokun GraphQL using the Bokun client context
 */
export function useBokunQuery<
  Data = unknown,
  Variables extends Record<string, unknown> = Record<string, never>,
>(args: UseQueryArgs<Variables, Data>) {
  const bokunClient = useContext(BokunClientContext);

  return useUrqlQuery({
    ...args,
    pause: (args.pause ?? false) || !bokunClient,
    context: { client: bokunClient },
  });
}
